import { Component, Input, OnInit } from '@angular/core';
import { Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import {
    selectJobQualificationChanges,
    selectJobQualificationChangesLoaded,
    selectJobQualificationChangesLoading
} from '../selectors/job-qualifications.selectors';
import { loadQualificationChanges } from '../actions/job-qualifications.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobQualificationChanges } from '../models/job-qualifications-changes.model';
import { JobQualificationsChangeTypeEnum } from '../enums/job-qualifications-change-type.enum';
import { AsyncPipe } from '@angular/common';
import { JobQualificationsRequiredTypeChangeComponent } from './changes/job-qualifications-required-type-change/job-qualifications-required-type-change.component';
import { JobQualificationsYearsOfExpChangeComponent } from './changes/job-qualifications-years-of-exp-change/job-qualifications-years-of-exp-change.component';
import { JobQualificationsChartingSystemChangeComponent } from './changes/job-qualifications-charting-system-change/job-qualifications-charting-system-change.component';
import { JobQualificationsPatientRatioChangeComponent } from './changes/job-qualifications-patient-ratio-change/job-qualifications-patient-ratio-change.component';
import { JobQualificationsCertsChangeComponent } from './changes/job-qualifications-certs-change/job-qualifications-certs-change.component';
import { JobQualificationsSkillsChangeComponent } from './changes/job-qualifications-skills-change/job-qualifications-skills-change.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-compare',
    templateUrl: './job-qualifications-compare.component.html',
    styleUrls: ['./job-qualifications-compare.component.scss'],
    standalone: true,
    imports: [
        JobQualificationsRequiredTypeChangeComponent,
        JobQualificationsYearsOfExpChangeComponent,
        JobQualificationsChartingSystemChangeComponent,
        JobQualificationsPatientRatioChangeComponent,
        JobQualificationsCertsChangeComponent,
        JobQualificationsSkillsChangeComponent,
        MatProgressSpinnerModule,
        AsyncPipe
    ]
})
export class JobQualificationsCompareComponent implements OnInit {
    data: JobQualificationChanges;

    @Input() jobId: number;
    @Input() shouldShowStateLicenseField = false;

    isLoading$: Observable<boolean>;
    changeType = JobQualificationsChangeTypeEnum;
    showAltCertsComparison = this._ldFeatureManager.isEnabledSignal(FeatureFlag.AltCertsJobDetailsCompToggle);

    constructor(
        private readonly store: Store,
        private readonly _ldFeatureManager: LDFeatureManager
    ) {}

    ngOnInit(): void {
        this.data = null;
        this.isLoading$ = this.store.select(selectJobQualificationChangesLoading);

        this.store
            .select(selectJobQualificationChangesLoaded)
            .pipe(take(1), untilDestroyed(this))
            .subscribe((isLoaded) => {
                if (!isLoaded) {
                    this.store.dispatch(loadQualificationChanges({ jobId: this.jobId }));
                }
            });

        this.store
            .select(selectJobQualificationChanges)
            .pipe(untilDestroyed(this))
            .subscribe((data) => {
                this.data = data;
            });
    }
}
